export const FILTER_GAMES = {
  ALL: 0, // Все игры
  FILTER: 1, // Игры, участвующие в акции
  EXCLUDE: 2, // Игры, не участвующие в акции
  GROUP_FILTER: 3, // Группы игр, участвующие в акции
  GROUP_EXCLUDE: 4, // Группы игр, не участвующие в акции
  ONLY_SPORT: 5, // Только спорт
}

export const DOC_STATUSES = {
  NotUploaded: 0, // "Не загружены"
  Verification: 1, // "Проверка документов"
  VerifiedAndValid: 2, // "Проверены и валидны"
  Declined: 3, // "Отклонены"
}

export const RESTRICTION = {
  NOT_READY: null,
  SERVICE_ALLOWED: false,
  SERVICE_NOT_ALLOWED: true,
}

export const BONUS_STEP_CONDITIONS = {
  TURNOVER: 2,
  DEPOSIT: 3,
  VAGER_BY_BONUS_BALANCE: 6,
}

export const BONUS_GAMES_STEP_CONDITIONS = [
  BONUS_STEP_CONDITIONS.TURNOVER,
  BONUS_STEP_CONDITIONS.VAGER_BY_BONUS_BALANCE,
]

export const APP_TYPES = {
  ANDROID_APP: '0',
  IOS_APP: '1',
  PWA: 2,
}

export const APP_IDS = {
  android: 111,
  ios: 112,
}

export const MB_UUIDS = {
  iosPwa: 'ec60563c-03c1-4b49-a676-2c3d3abb1dd6',
}

export const UNDER_DEV = {
  NOT_READY: null,
  ACTIVE: true,
  NOT_ACTIVE: false,
}

export const NAV_BAR_BUTTON_LINK_TYPE = {
  TOURNAMENT: 'A_0',
  GAME: 'A_1',
  FILTER: 'A_2',
  LINK: 'A_3',
  MENU: 'A_4',
  PROFILE: 'A_5',
}

export const APOLLO_CLIENTS = {
  default: 'default',
  clientGo: 'clientGo',
}

export const IN_GAME_MENU_MODE = {
  none: 0,
  header: 1,
  menu: 2,
}
